import { useTranslate } from "react-admin";

export default function DashBoard() {
  const translate = useTranslate();
  const t = (key: string) => translate(`menu.${key}`);

  return <>{t("dashboard")}</>;
}
